module.exports = __webpack_public_path__ + "media/images/application/template/flag-de-9164ccbe5f5cf07bad94d2bc310cd308.png";